import React, { useState } from 'react';
import { ReactComponent as ChevronSvg } from '../../svg/chevron.svg';
import integration from 'services/integration';
import './Accordion.css';

const Accordion = ({ title, titleIcon, content }) => {
  const [isActive, setIsActive] = useState(true);

  const showContent = (content && isActive) || (!title && !isActive);

  const onClick = (path) => {
    if (path) {
      integration.emit({ path }, 'iframe-navigation');
    }
  };

  return (
    <div className="accordion">
      <div className="accordion-item">
        {title && (
          <div
            className="accordion-title"
            onClick={() => setIsActive(!isActive)}
          >
            <div className="accordion-title__icon">{titleIcon}</div>
            <div className="accordion-title__text">{title}</div>
            {content && (
              <div
                className={`accordion-title__chevron ${
                  isActive ? 'active' : ''
                }`}
              >
                <ChevronSvg />
              </div>
            )}
          </div>
        )}
        {showContent &&
          content.map(({ label, path, icon }, i) => {
            return (
              <a
                href={path}
                className="accordion-content"
                key={i}
                onClick={(e) => {
                  e.preventDefault();
                  onClick(path);
                }}
              >
                {icon && <div className="accordion-content__icon">{icon}</div>}
                <div className="accordion-content__label">{label}</div>
              </a>
            );
          })}
      </div>
    </div>
  );
};

export default Accordion;
